import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import ClientSidebar from '../components/ClientSidebar';
import ClientHeader from '../components/ClientHeader';
import { Outlet } from 'react-router';
import Header from '@/components/Header';
import { Toaster } from 'sonner';

export default function ClientLayout() {
  return (
    <>
      <Header />
      <SidebarProvider
        className="relative h-full pt-(--header-height)"
        defaultOpen={true}
      >
        <ClientSidebar />
        <SidebarInset className="flex flex-col h-[calc(100vh-var(--header-height))] overflow-hidden">
          <ClientHeader />
          <main className="flex-1 min-h-0 overflow-auto p-6">
            <Outlet />
          </main>
        </SidebarInset>
      </SidebarProvider>
      <Toaster />
    </>
  );
}
